import { render, staticRenderFns } from "./ProductsWaistQuickAdd.vue?vue&type=template&id=7b38f054&"
import script from "./ProductsWaistQuickAdd.vue?vue&type=script&lang=js&"
export * from "./ProductsWaistQuickAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports